<template>
    <div class="row">
        <div class="col-md-12">
            <h2>Refine Search</h2>
            <a :href="getBackToSearch()" class="link back">Back to Full Search</a>
        </div>
        <div class="col-md-12">
           <!-- <div class="form-row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-12">
                            <h3>Auction Date</h3>
                        </div>
                       <div class="content-checkbox col-md-8">
                            <div class="checkbox">
                                <input type="checkbox" name="checkbox-6" class="checkbox" value="" id="checkbox-6">
                                <label for="checkbox-6">Wednesday 31 april</label>
                            </div>
                            <div class="checkbox">
                                <input type="checkbox" name="checkbox-5" class="checkbox" value="" id="checkbox-5">
                                <label for="checkbox-5">Wednesday 30 april</label>
                            </div>
                            <div class="checkbox">
                                <input type="checkbox" name="checkbox-4" class="checkbox" value="" id="checkbox-4">
                                <label for="checkbox-4">Wednesday 29 april</label>
                            </div>
                            <div class="checkbox">
                                <input type="checkbox" name="checkbox-3" class="checkbox" value="" id="checkbox-3">
                                <label for="checkbox-3">Wednesday 28 april</label>
                            </div>
                            <div class="checkbox">
                                <input type="checkbox" name="checkbox-2" class="checkbox" value="" id="checkbox-2">
                                <label for="checkbox-2">Wednesday 27 april</label>
                            </div>
                            <div class="checkbox">
                                <input type="checkbox" name="checkbox-1" class="checkbox" value="" id="checkbox-1">
                                <label for="checkbox-1">Wednesday 26 april</label>
                            </div>
                            <div class="checkbox">
                                <input type="checkbox" name="checkbox-0" class="checkbox" value="" id="checkbox-0">
                                <label for="checkbox-0">Wednesday 25 april</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="form-row">
                <div class="form-group col-lg-4 col-md-6 col-xs-12">
                    <label for="make">Make</label>
                    <select id="make" :name="getNameField('make')" class="form-control" v-model="data.make">
                        <option value="">All</option>
                        <option v-for="make in makes" :value="make.name">{{make.name}} ({{make.count}})</option>
                    </select>
                </div>
                <div class="form-group col-lg-4 col-md-6 col-xs-12">
                    <label for="model">Model<span class="required">*</span></label>
                    <input type="text" class="form-control"
                           readonly id="model"
                           :value="objectToString(selectedModels)"
                           :name="getNameField('model', selectedModels)"
                           placeholder="Model"
                           @click="showModelModal = true">
                    <b-modal size="lg" ref="ModalModel" id="modal-model" hide-footer :title="data.make" v-model="showModelModal" @hidden="onHideModelModal">
                        <div class="content-list-models">
                            <div class="form-group inline-label">
                                <label for="models-in-modal">Models</label>
                                <input type="text" readonly id="models-in-modal" :value="objectToString(selectedModels)" placeholder="Models">
                                <button type="button" class="link" @click="selectedModels = {}">Clear</button>
                                <button type="button" class="btn" @click="showModelModal = false">Done</button>
                            </div>
                            <div class="list-of-models" v-for="vehiclemodel of model_list">
                              <span class="checkbox">
                                   <input type="checkbox" :id="'make-'+vehiclemodel.name" :value="vehiclemodel.name" v-model="selectedModels[vehiclemodel.name]">
                                   <label :for="'make-'+vehiclemodel.name">{{ vehiclemodel.name }} ({{ vehiclemodel.count }})</label>
                              </span>
                            </div>
                        </div>
                    </b-modal>                </div>
                <div class="form-group col-lg-4 col-md-6 col-xs-12">
                    <label for="exclude_year_min"><span>Exclude Year</span></label>
                    <div class="form-row">
                        <div class="form-group col-md-5">
                            <select id="exclude_year_min" name="exclude_year_min" class="form-control" v-model="data.exclude_year_min">
                                <option value="" selected>Min</option>
                                <option v-for="year in years" :value="year">{{year}}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-2 middle">
                            <span>to</span>
                        </div>
                        <div class="form-group col-md-5">
                            <select id="exclude_year_max" name="exclude_year_max"  class="form-control"  v-model="data.exclude_year_max">
                                <option value="" selected>Max</option>
                                <option v-for="year in years" :value="year">{{year}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-lg-4 col-md-6 col-xs-12">
                    <label for="condition_min">Auction grade</label>
                    <div class="form-row">
                        <div class="form-group col-md-5">
                            <select id="condition_min" :name="getNameField('condition_min')" class="form-control" v-model="data.condition_min">
                                <option value="" selected>Min</option>
                                <option value="0.0">0.0</option>
                                <option value="2.0">2.0</option>
                                <option value="3.0">3.0</option>
                                <option value="3.5">3.5</option>
                                <option value="4.0" selected="TRUE">4.0</option>
                                <option value="4.5">4.5</option>
                                <option value="5.0">5.0</option>
                                <option value="9.0">9.0</option>
                            </select>
                        </div>
                        <div class="form-group col-md-2 middle">
                            <span>to</span>
                        </div>
                        <div class="form-group col-md-5">
                            <select id="condition_max" :name="getNameField('condition_max')" class="form-control" v-model="data.condition_max">
                                <option value="" selected>Max</option>
                                <option value="0.0">0.0</option>
                                <option value="2.0">2.0</option>
                                <option value="3.0">3.0</option>
                                <option value="3.5">3.5</option>
                                <option value="4.0">4.0</option>
                                <option value="4.5">4.5</option>
                                <option value="5.0">5.0</option>
                                <option value="9.0">9.0</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="form-group col-lg-4 col-md-6 col-xs-12" id="mileage">
                    <label for="mileage_min">Mileage</label>
                    <div class="form-row">
                        <div class="form-group col-md-5">
                            <input type="number" id="mileage_min" class="form-control" v-model="mileage_min_proxy"><span>,000</span>
                            <input type="hidden" :name="getNameField('mileage_min')" v-if="data.mileage_min" class="form-control" v-model="data.mileage_min">
                        </div>
                        <div class="form-group col-md-2 middle">
                            <span>to</span>
                        </div>
                        <div class="form-group col-md-5">
                            <input type="number" id="mileage_max" class="form-control" v-model="mileage_max_proxy"><span>,000</span>
                            <input type="hidden" :name="getNameField('mileage_max')" v-if="data.mileage_max" class="form-control" v-model="data.mileage_max">                        </div>
                    </div>
                </div>
                <div class="form-group col-lg-4 col-md-6 col-xs-12">
                    <label for="transmission">Transmission<span class="required">*</span></label>
                    <select id="transmission" class="form-control" name="transmission" v-model="data.transmission">
                        <option value="" selected>All</option>
                        <option value="1">Manual</option>
                        <option value="2">Automatic</option>
                        <option value="0">Unknown</option>
                    </select></div>
            </div>
            <div class="form-row">
                <div class="col-lg-8 col-md-6 col-xs-12">
                    <div class="row">
                        <div class="col-md-12">
                            <h3>Options</h3>
                        </div>
                        <div class="content-checkbox col-md-12">
                            <div class="latest checkbox">
                                <input type="checkbox" name="latest_listing" class="latest" value="latest" id="latest_listing" v-model="data.latest_listing" v-if="data.latest_listing" checked>
                                <input type="checkbox" name="latest_listing" class="latest" value="latest" id="latest_listing" v-model="data.latest_listing" else="">

                                <label for="latest_listing">Only Show latest listings</label>
                            </div>
                            <div class="exclude checkbox">
                                <input type="checkbox" name="exclude_listing" class="exclude" value="exclude" id="exclude_listing" v-model="data.exclude_listing" v-if="data.exclude_listing" checked>
                                <input type="checkbox" name="exclude_listing" class="exclude" value="exclude" id="exclude_listing" v-model="data.exclude_listing"  v-else="">

                                <label for="exclude_listing">Exclude already seen</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-md-6 col-xs-12">
                    <div class="buttons">
                        <div class="container-buttons">
                            <a href="#" class="btn btn-primary" @click="clearForm">Clear form</a>
                            <a href="#" class="btn btn-primary">Save Search</a>
                            <a href="#" class="btn btn-primary" @click="getSearchFormParameters">Search</a>
                        </div>

                        <div class="form-group inline-label">
                            <label for="saveSearch">Saved Search</label>
                            <input type="text" name="saveSearch" id="saveSearch" placeholder="Saved Search" class="form-control" v-model="data.saveSearch">
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-12">
                   <ul class="advance-search-tag">
                       <!-- <li :v-repeat="dataAdvance">
                        {{ dataAdvance}}
                       </li> -->
                       <template v-for="(item, index) in dataAdvance">
                          <template v-if="item">
                              <li  v-if="index == 'excluded_makes' || index == 'lot'">
                                  <span class="tag-name-group" v-if="item">{{ searchTags(index) }} <a v-on:click="removeFieldsFromSearch(index, value)" v-for="value in item.split(',')">{{ value }} <span class="remove-item">X</span></a></span>
                              </li>
                              <li  v-else>
                                  <span class="tag-name" v-if="item">{{ searchTags(index) }} <a v-on:click="removeFieldsFromSearch(index, item)">{{ item }} <span class="remove-item">X</span></a></span>
                              </li>
                          </template>
                       </template>


                   </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import searchMixin from '../mixins/VehicleSearch.vue';
    import { mapState } from 'vuex'
    export default {
        props: [
            'searchfields',
        ],
        mixins: [
            searchMixin
        ],
        mounted(){
            this.getMainSearchParameters();
            this.getMakeModelSelected();
            this.$store.dispatch('auction_search/maybeGetSearchData');
        },
        data(){
            return {
                data: {
                    make: this.searchfields.make ? this.searchfields.make : '' ,
                    model: this.searchfields.model ? this.searchfields.model : '' ,
                    exclude_year_min: this.searchfields.exclude_year_min ? this.searchfields.exclude_year_min : null,
                    exclude_year_max: this.searchfields.exclude_year_max ? this.searchfields.exclude_year_max : null,
                    condition_min: this.searchfields.condition_min ? this.searchfields.condition_min : null,
                    condition_max: this.searchfields.condition_max ? this.searchfields.condition_max : null,
                    mileage_min: this.searchfields.mileage_min ? this.searchfields.mileage_min : null,
                    mileage_max: this.searchfields.mileage_max ? this.searchfields.mileage_max : null,
                    transmission: this.searchfields.transmission ? this.searchfields.transmission : null,
                    saveSearch:this.searchfields.saveSearch ? this.searchfields.saveSearch : null,
                    exclude_listing:this.searchfields.exclude_listing ? this.searchfields.exclude_listing : '',
                    latest_listing:this.searchfields.latest_listing ? this.searchfields.latest_listing : '',
                },
                dataAdvance: {
                    year_min: this.searchfields.year_min ? this.searchfields.year_min : '' ,
                    year_max: this.searchfields.year_max ? this.searchfields.year_max : '',
                    chassis: this.searchfields.chassis ? this.searchfields.chassis : '',
                    engine_cc_min: this.searchfields.engine_cc_min ? this.searchfields.engine_cc_min : '',
                    engine_cc_max: this.searchfields.engine_cc_max ? this.searchfields.engine_cc_max : '',
                    start_bid_min: this.searchfields.start_bid_min ? this.searchfields.start_bid_min : '',
                    start_bid_max: this.searchfields.start_bid_max ? this.searchfields.start_bid_max : '',
                    colour: this.searchfields.colour ? this.searchfields.colour : '',
                    lot:this.searchfields.lot ? this.searchfields.lot : '',
                    hour_ago:this.searchfields.hour_ago ? this.searchfields.hour_ago : '',
                    excluded_makes:this.searchfields.excluded_makes ? this.searchfields.excluded_makes : '',
                },
                dates : {},
                auctions : {},
                selectedModels : {},
                model_active: false,
                showModelModal: false,
                getRefineSearchData: {},
                mileage_min_proxy: this.searchfields.mileage_min ? this.searchfields.mileage_min /1000 : null,
                mileage_max_proxy: this.searchfields.mileage_max ? this.searchfields.mileage_max /1000: null,
                refineFormData: {},

            }
        },
        computed: {
            ...mapState({
                years: state => state.auction_search.years,
                makes: state => state.auction_search.makes,
                dateCounters: state => state.auction_search.date_counters,
            }),
            model_list(){
                let models = []
                if (this.data.make && this.makes && this.makes.length) {
                    this.makes.forEach(make => {
                        if (make.name === this.data.make) {
                            models = make.models;
                        }
                    });
                }
                return models;
            },
        },
        watch: {
            mileage_min_proxy: function(new_value, old_value){
                this.data.mileage_min = new_value * 1000;
            },
            mileage_max_proxy: function(new_value, old_value){
                this.data.mileage_max = new_value * 1000;
            }
        },
        methods: {
            getBackToSearch() {
                let url = this.$laravelRoute('auction');
                return url
            },
             getMainSearchParameters(){
                let searchData = this.searchfields;
                let advanceSearchData = this.dataAdvance
                for (var i in searchData) {
                    this.refineFormData[i]= searchData[i];
                }
                 for (var j in advanceSearchData) {
                     this.refineFormData[j]= advanceSearchData[i];
                 }
            },
            getSearchFormParameters(){
                let model = $("#model").val();
                let searchData = this.data;
                for (var i in searchData) {
                    this.refineFormData[i]= searchData[i];
                }
                 if(model){
                     this.refineFormData['model'] = model;
                 }
                 if(this.refineFormData['make']){
                     this.refineFormData['excluded_makes'] = '';
                 }
                this.$emit('searchHandler', this.refineFormData);
                $("#refine-search-form").removeClass('show');

            },
            getMakeModelSelected(){
                 let modelList = [];
                 let allModels = {};
                 if (this.searchfields && this.searchfields.model) {
                     modelList = this.searchfields.model.split(',');
                     modelList.forEach(model => {
                         allModels[model] = true;

                     });
                 }
                this.selectedModels = allModels;
            },
            removeFieldsFromSearch(index, item){
                if(index == 'excluded_makes' || index == 'lot') {
                    let multipleData = '';
                    let getDataFromString = [];
                    let string = '';
                    multipleData = this.dataAdvance[index];
                    getDataFromString = multipleData.split(',')
                    for (var i = 0; i < getDataFromString.length;i++) {
                        if(getDataFromString[i] != item){
                            if((i + 1) == getDataFromString.length){
                                string += getDataFromString[i];
                            } else {
                                string += getDataFromString[i] +',';
                            }
                        }
                    }
                    this.dataAdvance[index] = string.replace(/(^,)|(,$)/g, "");
                } else {
                    this.$delete(this.dataAdvance, index);
                }
                this.refineFormData = this.dataAdvance;
                this.$emit('searchHandler', this.refineFormData);
                return false;
            },
            clearForm(){
                this.dates = {};
                this.auctions = {};
                this.selectedModels = {};
                this.excludedMakes = {};
                this.data = {};
                this.dataAdvance = {};
                this.$emit('searchHandler', this.refineFormData);
                return false;

            },
            searchTags: function(index){
                this.allDataAdvanceKeys = {
                    'start_bid_min' : 'Bid From:',
                    'start_bid_max': 'Bid To:',
                    'year_min': 'Year From:',
                    'year_max': 'Year To:',
                    'engine_cc_min': 'CC To:',
                    'engine_cc_max': 'CC From:',
                    'chassis': 'Chassis Number:',
                    'colour': 'Colour:',
                    'excluded_makes': 'Exclude Makes:',
                    'lot': 'Lot Number:',
                    'hour_ago': 'Hour ago:'
                };
                if(this.allDataAdvanceKeys[index]){
                   return this.allDataAdvanceKeys[index];
                }
                return '';

            }

        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/RefineSearch.vue